import { render, staticRenderFns } from "./VehicleFees.vue?vue&type=template&id=137a219f&scoped=true"
import script from "./VehicleFees.vue?vue&type=script&lang=js"
export * from "./VehicleFees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137a219f",
  null
  
)

export default component.exports